/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { RichTextComponent } from '@msdyn365-commerce/core';
import { AttributeValue } from '@msdyn365-commerce/retail-proxy';
import moment from 'moment';
import * as React from 'react';
import { IEventScheduleData } from './event-schedule.data';
import { IEventScheduleProps } from './event-schedule.props.autogenerated';

/**
 *
 * EventSchedule component
 * @extends {React.PureComponent<IEventScheduleProps<IEventScheduleData>>}
 */
class EventSchedule extends React.PureComponent<
  IEventScheduleProps<IEventScheduleData>
  > {
  private _productAttributeEventStartDate: string = 'START DATE';
  private _productAttributeEventEndDate: string = 'END DATE';
  private _productAttributeEventTimeRange: string = 'TIME RANGE';
  private _productAttributeEventLocation: string = 'SLR EVENT LOCATION';
  public render(): JSX.Element | null {
    const content: IEventScheduleData = this.props.data;
    if (
      !(
        content &&
        content.productSpecificationData &&
        content.productSpecificationData.result
      )
    ) {
      return null;
    }
    const eventScheduledata = content.productSpecificationData.result;
    if (eventScheduledata && eventScheduledata.length > 0) {
      const attributeEventLocation = eventScheduledata.filter(
        attribute => attribute.Name!.toUpperCase() === this._productAttributeEventLocation.toUpperCase());

      const attributeEventStartDate = eventScheduledata.filter(
        attribute => attribute.Name!.toUpperCase() === this._productAttributeEventStartDate.toUpperCase());

      const attributeEventEndDate = eventScheduledata.filter(
        attribute => attribute.Name!.toUpperCase() === this._productAttributeEventEndDate.toUpperCase());

      const attributeEventTime = eventScheduledata.filter(
        attribute => attribute.Name!.toUpperCase() === this._productAttributeEventTimeRange.toUpperCase());

      if ((attributeEventLocation && attributeEventLocation.length > 0 && attributeEventLocation[0].TextValue) ||
        (attributeEventStartDate && attributeEventStartDate.length > 0 && attributeEventStartDate[0].DateTimeOffsetValue) ||
        (attributeEventEndDate && attributeEventEndDate.length > 0 && attributeEventEndDate[0].DateTimeOffsetValue) ||
        (attributeEventTime && attributeEventTime.length > 0 && attributeEventTime[0].TextValue)
      ) {
        return (
          <div className='event-schedule'>
            {this._renderProductAttributes(
              attributeEventLocation,
              this._productAttributeEventLocation
            )}
            {this._renderDateAttributes(
              attributeEventStartDate,
              attributeEventEndDate
            )}
            {this._renderProductAttributes(
              attributeEventTime,
              this._productAttributeEventTimeRange
            )}
          </div>
        );
      } else { return null; }
    } else { return null; }
  }

  private _renderProductAttributes(
    productattribute: AttributeValue[],
    filter: string
  ): JSX.Element | null {
    if (productattribute && productattribute.length) {
      const classNameValue =
        filter === this._productAttributeEventLocation
          ? 'event-schedule-location'
          : filter === this._productAttributeEventTimeRange
            ? 'event-schedule-time' : '';
      if (productattribute[0].TextValue) {
        return (
          <RichTextComponent
            className={classNameValue}
            text={productattribute[0].TextValue}
          />
        );
      }
    }
    return null;
  }

  private _renderDateAttributes(
    startDateAttribute: AttributeValue[],
    endDateAttribute: AttributeValue[]
  ): JSX.Element | null {
    const classNameValue = 'event-schedule-date';
    const startDate = startDateAttribute && startDateAttribute.length ? moment(startDateAttribute[0].DateTimeOffsetValue).format('MMMM Do, YYYY') : null;
    let endDate = endDateAttribute && endDateAttribute.length ? moment(endDateAttribute[0].DateTimeOffsetValue).format('MMMM Do, YYYY') : null;

    if (startDate && endDate && startDate===endDate) {
      endDate = null;
    }

    if (startDate || endDate) {
      if (endDate) {
        return (
          <div className={classNameValue}><span>{`${startDate} - ${endDate}`}</span></div>
        );
      } else {
        return (
          <div className={classNameValue}><span>{startDate}</span></div>
        );
      }
    }
    return null;
  }
}

export default EventSchedule;
